/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PlaceWorkingHoursRequest } from './placeWorkingHoursRequest';
import { PlaceInformationLinkRequest } from './placeInformationLinkRequest';


export interface PlaceInformationRequest { 
    logo: string;
    phone1: string;
    phone2?: string;
    email: string;
    contactFirstName: string;
    contactLastName: string;
    placeWorkingHours?: Array<PlaceWorkingHoursRequest>;
    placeInformationLinks?: Array<PlaceInformationLinkRequest>;
}

